import React from 'react';

interface LoadingOverlayProps {
  message?: string;
}

export const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ message = 'Loading...' }) => {
  return (
    <div className="absolute inset-0 bg-white/70 flex items-center justify-center z-[1000]">
      <div className="flex flex-col items-center gap-2">
        <div className="h-8 w-8 border-4 border-rgf-primary-200 border-t-rgf-primary-600 rounded-full animate-spin" />
        <span className="text-sm text-rgf-gray-600">{message}</span>
      </div>
    </div>
  );
};
